import { render, staticRenderFns } from "./DetailFour.vue?vue&type=template&id=1b09c4f9&scoped=true"
import script from "./DetailFour.vue?vue&type=script&lang=ts"
export * from "./DetailFour.vue?vue&type=script&lang=ts"
import style0 from "./DetailFour.vue?vue&type=style&index=0&id=1b09c4f9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09c4f9",
  null
  
)

export default component.exports